import BaseContainer from './Index.vue'

BaseContainer.install = function(Vue) {
    Vue.component(BaseContainer.name, BaseContainer)
}

export default BaseContainer
